import React, { useState, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
 
import { volunteerService } from '../../Services';

import Loader from '../Common/Loader';

import {ReactComponent as Mail} from '../../images/icons/Communication/mail-01.svg';
import {ReactComponent as Arrow} from '../../images/icons/Arrows/corner-down-right.svg';

export const Teams = () => {
    const [teams, setTeams] = useState([]);
    const [emails, seEmails] = useState([]);
    const [loading, setLoading] = useState(false);

    const copyEmails = async (users) => {
        const emails = users.map(item => item['email']).join(';');
        await navigator.clipboard.writeText(emails);
    }

    const fetchData = useCallback(async () => {
        setLoading(true);

        const res = await volunteerService.getTeams();
        setTeams(Object.values(res.list));

        setLoading(false);
      }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <>
            <h1>Teams</h1>
            {loading ? <Loader /> :
            <div className="bordered-content">
                <div className="header">
                    <a href={`mailto:?bcc=${teams.map(team => team.users.map(item => item['email'])).flat().join(';')}`}>
                        <button className="primary" type="button"><Mail />Email all</button>
                    </a>
                    <a href={`mailto:?bcc=${teams.map(team => team.users.filter(item => item.teamLeader).map(item => item['email'])).flat().join(';')}`}>
                        <button className="primary" type="button"><Mail />Email all team leaders</button>
                    </a>
                </div>
                <div className="volouteer-teams">
                    {teams && teams.map((team) => (
                        <div key={team.id} className={`volouteer-team ${team.flexible && 'flexible'}`}>
                            <p>{team.name} {!team.flexible && <>: {team.weekday} {team.startTime} - {team.endTime}</>} <a href={`mailto:?bcc=${team.users.map(item => item['email']).join(';')}`}><Mail title="Team emails" /></a></p>
                            {team.users && team.users.length > 0 && (
                                <ul className="volouteer-team-users">
                                    {team.users.map((user, index) => (
                                        <li key={user.id} className={user.teamLeader ? 'team-leader' : ''}>
                                            <span className="index">{index+1}.</span><Link to={`/configuration/users/${user.id}`}>{user.firstName} {user.lastName}</Link> (<Link to={`/configuration/users/${user.id}/dives`}>{user.dives} dives</Link>) <a href={`mailto:${user.email}`}><Mail /></a>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}
                </div>
            </div>}
        </> 
    );
};

export default Teams;